import { useState, useEffect } from 'react';
import { Snackbar, Alert, Slide, Button } from '@mui/material';
import ErrorDialog from './SImpleDialoge';

function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

const SnackbarComponent = ({ open, handleClose, message = "", data = [], alertError = false }) => {
  const isArrayData = Array.isArray(data) && data.length > 0;
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    if (open && isArrayData) {
      setDialogOpen(false); // Reset dialog state when snackbar opens
    }
  }, [open, data]);

  const getMessage = () => {
    if (isArrayData) {
      return `${data.length} resumes are either corrupted or unsupported`;
    }
    if (typeof data === "string") return data;
    return message || "An error occurred";
  };

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={isArrayData ? 10000 : 5000}
        onClose={(_, reason) => {
          if (reason !== 'clickaway') {
            handleClose();
          }
        }}
        TransitionComponent={SlideTransition}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{
          // Place below a fixed 60px header with a small gap
          '&.MuiSnackbar-anchorOriginTopRight': { top: 'calc(60px + 8px)' }
        }}
      >
        <Alert
          severity={alertError || isArrayData ? "error" : "success"}
          sx={{ width: '100%' }}
          action={
            isArrayData && (
              <Button
                color="inherit"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  setDialogOpen(true);
                }}
              >
                Check
              </Button>
            )
          }
        >
          {getMessage()}
        </Alert>
      </Snackbar>

      {isArrayData && (
        <ErrorDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          errorMessage={data}
        />
      )}
    </>
  );
};

export default SnackbarComponent;
